// extracted by mini-css-extract-plugin
module.exports = {"achieve_wrapper":"style_achieve_wrapper__mI2JF","achieve_card_cist":"style_achieve_card_cist__eokpf"};